import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import { Root, ContainerTitle, ContainerOptions, Option } from './styles';

interface RadioOptionProps {
  id: string;
  label: string;
}

interface RadioProps {
  title: string;
  name: string;
  options: RadioOptionProps[];
  link?: string;
}

const Radio: React.FC<RadioProps> = ({ title, name, options, link }) => {
  const inputRef = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = '' } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: (refs: HTMLInputElement[]) => {
        const selected = refs.find(ref => ref.checked);
        return selected ? selected.value : '';
      },
      clearValue: (refs: HTMLInputElement[]) => {
        refs.forEach(ref => {
          ref.checked = false;
        });
      },
      setValue: (refs: HTMLInputElement[], value: string) => {
        refs.forEach(ref => {
          ref.checked = ref.value === value;
        });
      },
    });
  }, [fieldName, registerField]);

  return (
    <Root>
      <ContainerTitle>
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {title}
          </a>
        ) : (
          <span>{title}</span>
        )}
      </ContainerTitle>

      <ContainerOptions>
        {options.map((option, index) => (
          <Option htmlFor={option.id} key={option.id}>
            <input
              type="radio"
              id={option.id}
              name={fieldName}
              value={option.id}
              defaultChecked={option.id === defaultValue}
              ref={ref => {
                inputRef.current[index] = ref as HTMLInputElement;
              }}
            />
            <span>{option.label}</span>
          </Option>
        ))}
      </ContainerOptions>
    </Root>
  );
};

export default Radio;
